import { render, staticRenderFns } from "./production.vue?vue&type=template&id=29130930&"
import script from "./production.vue?vue&type=script&lang=ts&"
export * from "./production.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports